var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup264(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274,
    height: 274,
    viewBox: "0 0 274 274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7550 -3273)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 274,
    transform: "translate(7550 3273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,1V273H273V1H1M0,0H274V274H0Z",
    transform: "translate(7550 3273)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7587.45 3319.829)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.152 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.488,160.511H87.641a1.861,1.861,0,0,1-1.861-1.853V28.983a1.861,1.861,0,0,1,1.861-1.853h24.848a1.853,1.853,0,0,1,1.861,1.853V158.658a1.853,1.853,0,0,1-1.861,1.853ZM89.5,156.8h21.135V30.811H89.5Z",
    transform: "translate(-16.567 -5.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.984,25.532h-36.7a1.861,1.861,0,0,1-1.861-1.861V1.861A1.861,1.861,0,0,1,80.281,0h36.7a1.853,1.853,0,0,1,1.861,1.861V23.672a1.853,1.853,0,0,1-1.861,1.861ZM82.109,21.819h33.023V3.713H82.109Z",
    transform: "translate(-15.135 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.964,23.236H125.853A1.853,1.853,0,0,1,124,21.375V5.621a1.861,1.861,0,0,1,1.853-1.861h79.739a1.861,1.861,0,0,1,1.248.483L224.213,20a1.861,1.861,0,0,1-1.24,3.222Zm-95.251-3.713h90.435L204.866,7.441H127.713Z",
    transform: "translate(-24.003 -0.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.488,71.587H87.641a1.861,1.861,0,0,1-1.861-1.861V52.273a1.861,1.861,0,0,1,1.861-1.853h24.848a1.853,1.853,0,0,1,1.861,1.853V69.726a1.853,1.853,0,0,1-1.861,1.861ZM89.5,67.874h21.135V54.109H89.5Z",
    transform: "translate(-16.567 -9.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.488,117.937H87.641a1.861,1.861,0,0,1-1.861-1.853V98.631a1.861,1.861,0,0,1,1.861-1.861h24.848a1.853,1.853,0,0,1,1.861,1.861v17.454a1.853,1.853,0,0,1-1.861,1.853ZM89.5,114.224h21.135V100.483H89.5Z",
    transform: "translate(-16.567 -18.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.488,164.3H87.641a1.869,1.869,0,0,1-1.861-1.861V144.981a1.869,1.869,0,0,1,1.861-1.861h24.848a1.861,1.861,0,0,1,1.861,1.861v17.454a1.861,1.861,0,0,1-1.861,1.861ZM89.5,160.582h21.135V146.833H89.5Z",
    transform: "translate(-16.567 -27.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.488,160.5a1.885,1.885,0,0,1-1.12-.371L86.521,141.342a1.852,1.852,0,0,1-.741-1.514,1.885,1.885,0,0,1,.805-1.49l22.826-16.028L86.481,103.978a1.836,1.836,0,0,1-.693-1.506,1.861,1.861,0,0,1,.805-1.466l22.8-16L86.481,66.638a1.82,1.82,0,0,1-.693-1.506,1.844,1.844,0,0,1,.805-1.458l22.721-16L86.521,30.425a1.854,1.854,0,0,1,2.239-2.956l24.848,18.783a1.877,1.877,0,0,1,.741,1.514,1.853,1.853,0,0,1-.805,1.49L90.733,65.285l22.915,18.34a1.844,1.844,0,0,1,.7,1.506,1.877,1.877,0,0,1-.805,1.458l-22.81,16.036,22.915,18.332a1.861,1.861,0,0,1,.7,1.506,1.893,1.893,0,0,1-.805,1.466L90.79,139.917l22.818,17.253a1.853,1.853,0,0,1-1.12,3.335Z",
    transform: "translate(-16.567 -5.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.642,23.233a1.82,1.82,0,0,1-.95-.266L161.433,7.905,144.462,22.774a1.861,1.861,0,0,1-2.473,0L124.616,7a1.861,1.861,0,0,1,2.5-2.755l16.149,14.643L160,4.216a1.853,1.853,0,0,1,2.175-.193l25.234,15.062L204.371,4.216a1.861,1.861,0,0,1,2.473,0l17.373,15.754a1.856,1.856,0,0,1-2.489,2.755L205.619,8.083,188.842,22.774a1.877,1.877,0,0,1-1.2.459Z",
    transform: "translate(-24.015 -0.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.023,23.236H1.861A1.853,1.853,0,0,1,0,21.375V5.621A1.861,1.861,0,0,1,1.861,3.76H65.023a1.869,1.869,0,0,1,1.828,1.861V21.375a1.861,1.861,0,0,1-1.829,1.861ZM3.713,19.522h59.45V7.441H3.713Z",
    transform: "translate(0.122 -0.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.851,23.229a1.853,1.853,0,0,1-1.506-2.94L11.621,4.526a1.861,1.861,0,0,1,3,0L25.1,18.63,40.77,4.245A1.836,1.836,0,0,1,42.2,3.761a1.861,1.861,0,0,1,1.3.741L53.673,18.195,63.491,4.5a1.872,1.872,0,1,1,3.037,2.191l-11.3,15.779a1.853,1.853,0,0,1-3,0L41.761,8.377,26.111,22.738a1.853,1.853,0,0,1-2.755-.266L13.184,8.779,3.365,22.472a1.877,1.877,0,0,1-1.514.757Z",
    transform: "translate(0.124 -0.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.273,203.593H74.9a1.853,1.853,0,0,1-1.853-1.853V189.981A1.853,1.853,0,0,1,74.9,188.12h45.37a1.861,1.861,0,0,1,1.861,1.861v11.735a1.861,1.861,0,0,1-1.861,1.877Zm-43.494-3.713h41.649v-8.054H76.763Z",
    transform: "translate(-14.09 -36.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.931,220.168H62.361a1.861,1.861,0,0,1-1.861-1.861V204.551a1.861,1.861,0,0,1,1.861-1.861h65.571a1.853,1.853,0,0,1,1.861,1.861v13.733a1.853,1.853,0,0,1-1.861,1.885Zm-63.71-3.713h61.858V206.427H64.221Z",
    transform: "translate(-11.649 -39.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.885,64.878A1.853,1.853,0,0,1,25,63.026V25.17a1.861,1.861,0,0,1,3.713,0V63.026a1.853,1.853,0,0,1-1.829,1.853Z",
    transform: "translate(-4.742 -4.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9,108.3H15.332a7.12,7.12,0,0,1-7.112-7.112v-23.8a7.12,7.12,0,0,1,7.112-7.112H31.9a7.12,7.12,0,0,1,7.112,7.112v23.8A7.12,7.12,0,0,1,31.9,108.3ZM15.332,73.993a3.4,3.4,0,0,0-3.391,3.4v23.8a3.4,3.4,0,0,0,3.391,3.391H31.9a3.4,3.4,0,0,0,3.391-3.391v-23.8a3.4,3.4,0,0,0-3.391-3.4Z",
    transform: "translate(-1.477 -13.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.816,223.492H53.261a1.861,1.861,0,1,1,0-3.713H208.816a1.861,1.861,0,0,1,0,3.713Z",
    transform: "translate(-9.854 -42.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.784,223.492H1.831a1.861,1.861,0,1,1,0-3.713H6.784a1.861,1.861,0,0,1,0,3.713Z",
    transform: "translate(0.152 -42.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.528,223.492H22.651a1.861,1.861,0,1,1,0-3.713h7.877a1.861,1.861,0,1,1,0,3.713Z",
    transform: "translate(-3.899 -42.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.064,223.492H47.111a1.861,1.861,0,1,1,0-3.713h4.953a1.861,1.861,0,0,1,0,3.713Z",
    transform: "translate(-8.658 -42.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.081,211.635a1.861,1.861,0,0,1-1.861-1.861v-4.953a1.861,1.861,0,1,1,3.721,0v4.953A1.861,1.861,0,0,1,237.081,211.635Z",
    transform: "translate(-45.642 -39.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.081,180.385a1.861,1.861,0,0,1-1.861-1.853v-9.714a1.861,1.861,0,1,1,3.721,0v9.714a1.861,1.861,0,0,1-1.861,1.853Zm0-24.276a1.869,1.869,0,0,1-1.861-1.861v-9.7a1.861,1.861,0,0,1,3.721,0v9.665a1.869,1.869,0,0,1-1.861,1.893Z",
    transform: "translate(-45.642 -27.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.081,127.107a1.861,1.861,0,0,1-1.861-1.853V120.3a1.861,1.861,0,0,1,3.721,0v4.953A1.861,1.861,0,0,1,237.081,127.107Z",
    transform: "translate(-45.642 -23.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,201.191H152.863a1.853,1.853,0,0,1-1.852-1.861V107a1.853,1.853,0,0,1,1.853-1.853H220.7A1.861,1.861,0,0,1,222.557,107v10.712a1.861,1.861,0,0,1-3.721,0v-8.86H154.723v88.6h64.113V190.72a1.861,1.861,0,0,1,3.721,0v8.586a1.861,1.861,0,0,1-1.861,1.885Z",
    transform: "translate(-29.258 -20.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6,217.588H175.943a1.852,1.852,0,0,1-1.853-1.861V191.283a1.853,1.853,0,0,1,1.853-1.853H206.6a1.853,1.853,0,0,1,1.861,1.853v24.445a1.853,1.853,0,0,1-1.861,1.861ZM177.8,213.875h26.942V193.111H177.8Z",
    transform: "translate(-33.749 -36.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.636,37.184H180.393a1.853,1.853,0,0,1-1.853-1.861V25.183a1.853,1.853,0,0,1,1.853-1.853h24.244a1.853,1.853,0,0,1,1.861,1.853v10.14a1.853,1.853,0,0,1-1.861,1.861ZM182.253,33.47h20.531V27.027H182.253Z",
    transform: "translate(-34.614 -4.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.854,85.412H144.023a1.861,1.861,0,0,1-1.853-1.861V73.943a1.853,1.853,0,0,1,1.853-1.853h82.831a1.852,1.852,0,0,1,1.861,1.853v9.609A1.861,1.861,0,0,1,226.854,85.412Zm-80.971-3.729h79.11V75.8h-79.11Z",
    transform: "translate(-27.538 -14.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.983,49.58a7.9,7.9,0,0,1-7.893-7.893V37.781a1.861,1.861,0,0,1,1.861-1.861h12.082a1.853,1.853,0,0,1,1.853,1.861v3.906a7.893,7.893,0,0,1-7.9,7.893Zm-4.18-9.947v2.054a4.18,4.18,0,0,0,8.36,0V39.633Z",
    transform: "translate(-36.083 -6.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.442,71.139a1.853,1.853,0,0,1-1.853-1.861V50.1a1.861,1.861,0,1,1,3.713,0V69.279a1.853,1.853,0,0,1-1.861,1.861Z",
    transform: "translate(-37.541 -9.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.973,217.616a1.852,1.852,0,0,1-1.852-1.861V191.31a1.861,1.861,0,0,1,3.713,0v24.445a1.852,1.852,0,0,1-1.861,1.861Z",
    transform: "translate(-37.451 -36.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.162,139.871H162.551a1.853,1.853,0,0,1-1.861-1.861v-17.72a1.861,1.861,0,0,1,1.861-1.861h52.611a1.861,1.861,0,0,1,1.852,1.861v17.72a1.853,1.853,0,0,1-1.853,1.861Zm-50.743-3.713h48.874V122.151H164.4Z",
    transform: "translate(-31.141 -23.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.162,170.149H162.551a1.861,1.861,0,0,1-1.861-1.861V150.553a1.853,1.853,0,0,1,1.861-1.852h52.611a1.853,1.853,0,0,1,1.853,1.853v17.72a1.861,1.861,0,0,1-1.853,1.877Zm-50.743-3.721h48.874v-14H164.4Z",
    transform: "translate(-31.141 -28.931)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup264);
export default __webpack_public_path__ + "static/media/Group264.cf881e12a3d914f84e73241bb2434515.svg";
export { ForwardRef as ReactComponent };